import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css']
})
export class DatePickerComponent implements OnInit {

  @Input() value;
  @Input() fieldName;

  @Output() public selected = new EventEmitter();

  inputValue;
  placeholder = '';
  // GUI Values
  inputLabel;
  inputHint;

  shortDate;
  editingMode = false;

  constructor(private comonFunctions: FunctionsService) {}

  ngOnInit(): void {
    // Field Name From CrudFieldsService
    this.value? this.inputValue = this.value : this.inputValue = null;
    this.fieldName? this.inputLabel = this.fieldName : this.inputLabel = null;
  }

  switchEditingMode(field){
    this.editingMode = !this.editingMode;
    //this.crudFieldsData.switchEditingMode(field,this.data.crudId);
  }

  isEditingMode(field){
    return this.editingMode;
    //return this.crudFieldsData.isEditingMode(field,this.data.crudId);
  }

  onDateChange(e){
    this.shortDate = this.inputValue.toLocaleDateString('en-GB');
    this.shortDate.toString("DD MM yyyy");
    this.selected.emit(this.shortDate);
    // Sent to DDBB
    //this.crudFieldsData.addValueToFieldInObj(this.data.fieldName,this.comonFunctions.getOnlyDate(this.inputValue),this.data.crudId);
  }

}
